import _ from 'lodash'
import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import {IMAGEX_CUSTOM_DESIGN_TYPE, getFieldMapping, SCOPED_DATA, ScopedDataItem, URL_PARAM_TO_PATH} from './constants'
import {packToQueryParams} from '../../utils/urlParams'
import {moveFields} from '../../utils/mapFields'

const mapScopedDataItems = (component: ComponentExportStructure) => {
    const convertedScopedData: ScopedDataItem[] = []

    component.data?.scopedData?.forEach((sd: ScopedDataItem) => {
        moveFields(sd, SCOPED_DATA)

        delete sd.displayMode
        delete sd.clickAction

        if (!_.isEmpty(sd)) {
            sd.type = IMAGEX_CUSTOM_DESIGN_TYPE
            convertedScopedData.push(sd)
        }
    })

    component.data.scopedData = convertedScopedData
}

const convertScopedDataToDesign = (component: ComponentExportStructure) => {
    const [[defaultDesign], variantsData] = _.partition(
        component.data.scopedData,
        (sd: ScopedDataItem) => !sd.breakpoint
    )

    if (!_.isEmpty(defaultDesign)) {
        component.design ??= {}
        component.design.default = defaultDesign
    }

    const variants = variantsData.map((sd: ScopedDataItem) => {
        const breakpointId = sd.breakpoint
        delete sd.breakpoint

        return {
            conditions: [breakpointId],
            value: sd
        }
    })

    if (variants.length > 0) {
        component.design ??= {}
        component.design.variants = variants
    }

    delete component.data.scopedData
}

export const pack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    const defaultDesignIndex = component.data.scopedData.findIndex((sd: ScopedDataItem) => !sd.breakpoint)
    const defaultDesignPath = `data.scopedData.${defaultDesignIndex}`

    moveFields(component, getFieldMapping(defaultDesignPath))
    mapScopedDataItems(component)
    convertScopedDataToDesign(component)

    component.src = packToQueryParams(component, 'src', _.invert(URL_PARAM_TO_PATH))
}
